import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCalendarCheck, FaUserMd } from "react-icons/fa";
import CommonNavbar from "./CommonLayout/CommonNavbar";
import CommonFooter from "./CommonLayout/CommonFooter";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import 'animate.css';
import "../../assets/css/Home.css";

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <>
      <CommonNavbar />

      {/* HERO SECTION */}
      <div className="hero-section d-flex align-items-center text-center">
        <Container>
          {loading ? (
            <>
              <Skeleton height={50} width="60%" className="mb-3" />
              <Skeleton height={20} width="80%" className="mb-4" />
              <Skeleton height={45} width={200} className="mr-3" />
              <Skeleton height={45} width={250} />
            </>
          ) : (
            <>
              <h1 className="hero-title animate__animated animate__fadeInDown">
                Your Trusted Counselling Platform
              </h1>
              <p className="hero-subtitle animate__animated animate__fadeInUp">
                Book appointments with expert Psycho-Oncologist 
              </p>
              <div className="hero-buttons mt-4">
                <Link to="/create-account">
                  <Button variant="primary" size="lg" className="mr-3">
                    <FaCalendarCheck className="mr-2" /> Book Appointment
                  </Button>
                </Link>
                <Link to="/create-counsellor-account">
                  <Button variant="outline-light" size="lg">
                    <FaUserMd className="mr-2" /> Register as Counsellor
                  </Button>
                </Link>
              </div>
            </>
          )}
        </Container>
      </div>

      <CommonFooter />
    </>
  );
};

export default Home;
